import styled from "styled-components";

export const TextModal = styled.div`
  width: 468px;
`;
